export default "/images/right_arrow.png?de80ef413ccff2d7daa7ca0541150471";